<template>
  <div v-if="visible" style="display: inline-block;">
    <v-btn ref="button" v-bind="$attrs" v-on="$listeners" class="mx-1 on-primary--text" color="primary">
      <v-icon :small="small">{{ icon }}</v-icon>
      {{ text }}
    </v-btn>
    <v-tooltip v-if="hasTooltip" bottom :activator="$refs.button && $refs.button.$el">
      <span>{{ tooltip }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "CreateBtn",
  computed: {
    hasTooltip() {
      return !!this.tooltip
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    text: {
      type: String,
      default: "Nowy",
    },
    tooltip: {
      type: String,
      default: null
    },
    small: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: "mdi-car"
    },
  }
}
</script>
